import type { ToastView } from '../types';
import { CloseButton, ToastItem } from './parts';
import { cardStyle, isPhone } from './style';
import './toast.css';

// Вид 'Icons' (макет telecom, раздел 8): белая плашка с тенью бренда, иконка
// типа в тонированном круге, жирный текст в одну-две строки, крестик и полоска
// оставшегося времени цветом типа. 2 секунды (у макета 4, сократили по слову
// юзера 24.09), наведение таймер НЕ останавливает (так в макете), новые
// уведомления встают сверху. На десктопе —
// справа под строкой аккаунта, на телефоне — во всю ширину под верхней панелью.
//
// Иконка и крестик выровнены по центру высоты плашки: в макете у текста в две
// строки иконка висела у верхнего края (замечание юзера 24.09).
//
// Подставленное имя («FB · Bangladesh» в «Поток «…» сохранён») — цветом бренда:
// всё, что в кавычках, красится целиком вместе с кавычками.

const view: ToastView = {
  ToastItem,
  toastOptions: (type) => ({
    className: 'tc-toast',
    style: cardStyle(type),
    position: isPhone(window.innerWidth) ? 'top-center' : 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    icon: false,
    closeButton: CloseButton,
  }),
  containerProps: (screenWidth) => ({
    newestOnTop: true,
    // transform: none — у top-center библиотека центрует контейнер через
    // left: 50% + translateX(-50%) и сбрасывает сдвиг сама только до 480px; при
    // нашем left: 12px на 481–639px плашка уезжала за левый край на полширины.
    style: isPhone(screenWidth)
      ? { top: '72px', left: '12px', width: 'calc(100vw - 24px)', padding: 0, transform: 'none' }
      : { top: '96px', right: '24px', width: '340px' },
  }),
};

export default view;
